// Common mapping for document type values to user-friendly labels
export const reminderTypeLabels: Record<string, string> = {
    inspection: "Inspection",
    service: "Service",
    warranty: "Warranty",
    other: "Other"
};
